// @ts-expect-error  Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageContentSection from '../../primary-message/components/PrimaryMessageContentSection';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPrimaryMessageContentSection = styled(PrimaryMessageContentSection).withConfig({
  displayName: "AutomatedMessageContent__StyledPrimaryMessageContentSection",
  componentId: "qm93so-0"
})(["padding-left:8px;padding-right:8px;padding-bottom:8px;"]);
const AutomatedMessageContent = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyledPrimaryMessageContentSection, {
    children: children
  });
};
AutomatedMessageContent.displayName = 'AutomatedMessageContent';
export default AutomatedMessageContent;